module.exports = __webpack_public_path__ + "assets/img/sabc_social_youtube.webp?b455d201b133c2ffb49b9094ae0e1d04";